<template>
  <ComplianceUpdatedByCell
    :data-test="`compliance-updated-by-${index}`"
    :reviewer-name="reviewerName"
    :reviewed-at="reviewedAt"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ComplianceUpdatedByCell from '@/components/GraphqlDataTable/columns/Compliance/ComplianceUpdatedByCell.vue'
import {
  complianceDate,
  complianceReviewerName,
  VerifiedComplianceDateKey,
} from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const ComplianceUpdatedByColumn = graphql(`
  fragment ComplianceUpdatedByColumn on TrustedContact {
    id
    verifiedCompliance: compliances(names: [VERIFIED_WORKER_COMPLIANCE], cached: true) {
      name
      data {
        ...VerifiedComplianceUser
        ...VerifiedComplianceDate
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ComplianceUpdatedByColumn>
  index: number
}>()

const column = computed(() => useFragment(ComplianceUpdatedByColumn, props.row))
const data = computed(() => column.value.verifiedCompliance?.[0]?.data)
const reviewerName = computed(() => complianceReviewerName(data.value))
const reviewedAt = computed(() => complianceDate(data.value, VerifiedComplianceDateKey.ReviewedAt))
</script>
